export const CUSTOMERS_LOGOS = [
  {
    id: 1,
    path: '/images/customers-wildwooo.svg',
    alt: 'Wildwooo customer icon',
  },
  {
    id: 2,
    path: '/images/customers-apple.svg',
    alt: 'Apple customer icon',
  },
  {
    id: 3,
    path: '/images/customers-symbol.svg',
    alt: 'Symbol customer icon',
  },
  {
    id: 4,
    path: '/images/customers-group.svg',
    alt: 'Group customer icon',
  },
  {
    id: 5,
    path: '/images/customers-hard.svg',
    alt: 'Hard customer icon',
  },
  {
    id: 6,
    path: '/images/customers-fairtech.svg',
    alt: 'Fairtech customer icon',
  },
];
